import { cn } from "@/utils"

interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: "success" | "error" | "warning" | "info"
  children: React.ReactNode
}

export function Alert({ variant = "info", className, children, ...props }: AlertProps) {
  return (
    <div
      className={cn(
        "p-4 rounded-lg",
        {
          "bg-green-50 text-green-800 border border-green-200": variant === "success",
          "bg-red-50 text-red-800 border border-red-200": variant === "error",
          "bg-yellow-50 text-yellow-800 border border-yellow-200": variant === "warning",
          "bg-blue-50 text-blue-800 border border-blue-200": variant === "info",
        },
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
} 